import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';

import type { TypeExchangeDetailData } from '~/types/claim.types';

type TypeExchangeDeliveryInfo = TypeExchangeDetailData['exchangeOrder']['exchangeOrderItems'][number];

/**
 * [교환 신청/조회] 신청 상세 모달 > '교환 배송 정보' 테이블 컬럼 정의
 */
const getClaimExchangeDetailDeliveryColumnDefs = ({
  onClickOutboundOrderCode,
}: {
  onClickOutboundOrderCode: (outboundOrderCode: string) => void;
}) => {
  const columnDefs: TypeTableColumn<TypeExchangeDeliveryInfo>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'outboundOrderCode',
      header: '출고요청번호',
      size: 180,
      cell: ({ getValue, row }) => {
        const { outboundOrderCode } = row.original;
        return (
          <TextButtonCell
            value={getValue()}
            onClick={() => {
              if (!outboundOrderCode) return;
              onClickOutboundOrderCode(outboundOrderCode);
            }}
          >
            {outboundOrderCode}
          </TextButtonCell>
        );
      },
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 130,
    },
    {
      accessorKey: 'goodsName',
      header: '상품명',
      minSize: 438,
      meta: { flex: true },
    },
    {
      accessorKey: 'quantity',
      header: '배송수량',
      size: 76,
      meta: { cellStyle: { textAlign: 'right' } },
    },
  ];

  return { columnDefs };
};

export default getClaimExchangeDetailDeliveryColumnDefs;
